import WorkCubeInEngLogDBService from "../../db-services/workCubeInEngLogDBService";
import { ILogResponseModel } from "../types";


class WorkCubeInEngLogService {
    private dbService;

    constructor() {
        this.dbService = new WorkCubeInEngLogDBService();
    }

    async getAllLogs(dayAgo: number): Promise<ILogResponseModel[]> {
        try {
            const response = await this.dbService.getAll(dayAgo)
            return response
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

}


export default WorkCubeInEngLogService;
